import React from 'react';
import { SessionMessagesProps } from '../types';
import Messages from '../components/Messages';

/**
 * A component to display session messages.
 */
const SessionMessages: React.FC<SessionMessagesProps> = Messages;

export default SessionMessages;
